export const AUTHENTICATED = '[ACTION] AUTHENTICATED';

export function authenticated(authenticatedFlag: boolean) {
	return {
		type: AUTHENTICATED,
		payload: authenticatedFlag,
	};
}
